import SliderRow from '@dc-shared-web/components/features/AIConfigDialog/SliderRow'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'

const TemperatureRow = ({
  values,
  disabled,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (value: number) => {
    onChange({ ...values, temperature: value })
  }

  return (
    <SliderRow
      label='Temperature'
      value={values.temperature}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}

export default TemperatureRow
